import React from "react";
import FormattedDate from "../FormattedDate";
import { Link } from "gatsby";
import styled from "styled-components";
import ArticleByline from "./ArticleByline";

const ArticleHero = ({ 
  authors = undefined,
  datePublished = undefined,
  figure = undefined, 
  shortTitle = undefined,
  subtitle = undefined,
  title = undefined, 
}) => {
  return (
    <StyledArticleHero>
      {/*shortTitle && <h2>{shortTitle}</h2>*/}
      {title && <h1>{title}</h1>}
      {figure && <figure>{figure}</figure>}
      {subtitle && <p>{subtitle}</p>}
      <div>
        <ArticleByline authors={authors} />
        {datePublished && (
          <FormattedDate 
            date={datePublished} 
            format={{
              year: "numeric",
              month: "long",
              day: "numeric",
              timeZone: "America/New_York"
            }} 
          />
        )}
      </div>
    </StyledArticleHero>
  );
};
export default ArticleHero;

const StyledArticleHero = styled.header`
  position: relative;
  padding-top: 3.5em;
  text-align: center;
  display: grid;
  grid-template: auto / 1fr;
  gap: 3em;
  &::after {
    content: "";
    position: relative;
    display: block;
    width: 100%;
    max-width: var(--text-max-width);
    margin: 0 auto;
    border-bottom: 1.5px solid #aaa;
  }
  h2 {
    font-family: var(--font-heading);
    font-size: 0.875em;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.15em;
    margin: 0 auto;
  }
  h1 {
    font-family: var(--font-heading);
    font-weight: 700;
    font-size: 1.875em;
    text-transform: uppercase;
    line-height: 1.3;
    letter-spacing: 0.1em;
    margin: 0;
  }
  p {
    font-size: 1.25em;
    font-family: var(--font-serif);
    margin: 0 auto;
    max-width: 32em;
  }
  figure {
    position: relative;
    margin: 0 auto;
  }

  address,
  time {
    font-family: var(--font-heading);
    font-size: 0.875em;
    letter-spacing: 0.025em;
  }
  address {
    font-weight: 700;
    font-style: normal;
    a {
      transition: opacity 0.3s ease;
    }
    .can-hover & a:hover {
      opacity: 0.5;
      text-decoration-line: underline;
      text-decoration-thickness: 0.75px;
      text-underline-offset: 0.1em;
      text-decoration-color: var(--theme-text-against-dark-medium);
    }
  }
  
  @media ( max-width: 40em ) {
    address:not(:last-child) {
      margin-bottom: 0.5em;
    }
  }
  @media ( min-width: 40em ) {
    address,
    time {
      font-size: 1em;
    }
    address {
      display: inline;
    }
    time {
      &:not(:first-child)::before {
        content: " / ";
        margin: 0 0.5em;
      }
    }
  }
  @media ( max-width: 48em ) {
    figure {
      width: 100vw;
      left: 50%;
      margin-left: -50vw;
    }
  }
  @media ( min-width: 48em ) {
    gap: 4em;
    h2 {
      font-size: 1.5em;
    }
    h1 {
      font-size: 2.5em;
    }
    p {
      font-size: 1.5em;
    }
  }
  @media ( min-width: 60em ) {
    padding-top: clamp(8.25em, 60vh, 10.25em);
    h1 {
      font-size: 3.75em;
      letter-spacing: 0.0625em;
    }
    p {
      font-size: 2em;
      line-height: 1.6;
    }
  }
`;